import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { bricolage, figtree, jetbrains } from '@/lib/design/fonts'

const fontVariables = `:root{--font-app-sans:${figtree.style.fontFamily};--font-app-mono:${jetbrains.style.fontFamily};--font-app-heading:${bricolage.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <TooltipProvider delay={300}>
                <Component {...pageProps} />
            </TooltipProvider>

            <Toaster theme='light' position='bottom-center' richColors={false} />
        </div>
    )
}

export default App
